document.addEventListener('DOMContentLoaded', function() {
  const boton = document.getElementById('abrir-puerta');
  const formulario = document.getElementById('form-secreto');

  boton.addEventListener('click', function() {
    if (formulario.style.display === 'none' || formulario.style.display === '') {
      formulario.style.display = 'block';
    } else {
      formulario.style.display = 'none';
    }
  });
});
